import { render, staticRenderFns } from "./Medias.vue?vue&type=template&id=47faaa6f"
import script from "./Medias.vue?vue&type=script&lang=js"
export * from "./Medias.vue?vue&type=script&lang=js"
import style0 from "./Medias.vue?vue&type=style&index=0&id=47faaa6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports